module.exports = "img/feather-customised/eye.52aa0d2.svg";